<template>
    <div>
        <div class="container text-center mt-2 mb-3">
            <div id="div-modal-anular" class="w-100">
                <div id="div-anular" class="card w-100">
                    <div class="card-header text-white h5 bg-main text-center">
                        <span class="col btn border border-white text-white" style="float: left;" @click="mtdBehindStep()"><strong>ATRAS</strong></span>
                        <strong style="display: inline-block;">RESERVA DE {{elementProcess.name}}</strong>
                        <span class="btn border border-white text-white" style="float: right;" @click="mtdNextStep()"><strong>SIGUIENTE</strong></span>
                    </div>
                    <div class="card-body w-100">
                        <div class="row  mt-2 mb-2">
                            <div class="col-sm-12 col-md-12 col-xl-8">
                                <div id="div-modal-anular" class="w-100">
                                    <div id="div-anular" class="card w-100">
                                        <div class="card-body w-100">
                                            <header class="card-header bg-main text-white align">
                                                <h6 class="card-title ">DR(A). {{elementProcess.doctor.name}}</h6>
                                            </header>
                                            <div class="row">
                                                <div class="col-md-12 py-2">
                                                    <div class="card-body">
                                                        <FullCalendar :options="calendarOptions" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-xl-4 mb-4">
                                <div id="div-anular" class="card w-100">
                                    <div class="card-body w-100">
                                        <section class="card">
                                            <header class="card-header bg-main text-white align">
                                                <h6 class="card-title ">CREAR CITA</h6>
                                            </header>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class="col-form-label label-modal">Fecha</label>
                                                            <input type="text" class="form-control" autocomplete="off"
                                                              name="date" v-model="quote.date" disabled  placeholder="Seleccione  una fecha" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12" v-if="quote.date">
                                                        <div class="form-group">
                                                            <label class="col-form-label label-modal">Consultorios</label>
                                                            <div>
                                                                <v-select id="patientSelect"
                                                                    class="text-dark form-control" :options="conRoom"
                                                                    v-model="selectedConRoom"
                                                                    :reduce="(name) => name.id" label="name"
                                                                    placeholder="Seleccione Consultorio" required
                                                                    :clearable="false"
                                                                    @input="mtdSelectTab(selectedConRoom)"
                                                                    />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 mt-2" v-if="selectedConRoom">
                                                        <div class="table-responsive">
                                                            <table aria-describedby="mydesc" class="table table-striped table-scroll text-xs">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Horas</th>
                                                                        <th scope="col" class="table-th-hour"><i class="fas fa-calendar-check"></i> Estado</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr class="table-body text-center" v-for="(item, index) in schedule.hours" :key="index">
                                                                        <td class="cursor" style="padding: 2px !important">
                                                                            <button 
                                                                                type="button" 
                                                                                class="btn btn-xs input-group-text form-control" style="padding: 0px !important"
                                                                                :class="{
                                                                                    'btn-blue text-white': selectedHour === item.name && item.state === 1,
                                                                                    'btn-warning': item.state === 2
                                                                                }"
                                                                                :disabled="item.state !== 1"
                                                                                @click="item.state === 1 ? selectHour(item.name) : null"
                                                                            >
                                                                                {{ item.name }}
                                                                            </button>
                                                                        </td>
                                                                        
                                                                        <td style="padding: 2px !important">
                                                                            <div id="state_speciality" v-if="item.state == 1">
                                                                                <div class="bg-success text-white fw-semibold font-hour-state">Libre</div>
                                                                            </div>
                                                                            <div id="state_speciality" v-else-if="item.state == 2">
                                                                                <div class="bg-warning fw-semibold font-hour-state">Reservado</div>
                                                                            </div>
                                                                            <div id="state_speciality" v-else-if="item.state == 3">
                                                                                <div class="bg-danger text-white fw-semibold nowrap font-hour-state">Ocupado</div>
                                                                            </div>
                                                                            <div id="state_speciality" v-else>
                                                                                <div class="bg-secondary text-white fw-semibold nowrap font-hour-state">No Disponible</div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import cModalCitasVue from '@/components/Admision/ventas/Modals/cModalCitas.vue';
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import FullCalendar from '@fullcalendar/vue';
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment';

export default {
    name: 'c-call-citas',
    components: {
        FullCalendar,
        cModalCitasVue,
        SweetAlert,
    },
    props:{
     elementProcess:Object,
    },
    data() {
        return {
            swal: null,
            selectedHour: '',
            viewInput: null,
            pos: 0,
            showCalendar: false,
            serviceOptions: [],
            medics: [],
            patients: [],
            turns: [],
            ofHours: [],
            conRoom: [],
            opeRoom: [],
            imgRoom: [],
            calendarOptions: {
                locale: "es",
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                events: [],
                initialView: "dayGridMonth",
                buttonText: {
                    today: "Hoy",
                    month: "Meses",
                    week: "Semanas",
                    day: "Días",
                },
                headerToolbar: {
                    left: "title",
                    center: "",
                    right: "prev today next",
                },
                weekends: true,
                selectable: true,
                editable: false,
                validRange: {
                    start: Date.now(),
                },
                dateClick: this.dateClick,
                dayMaxEventRows: true,
                views: {
                    timeGrid: {
                        dayMaxEventRows: 6
                    }
                }
            },
            events: [],
            quote: {
                dateStr: '',
                campu_id: null,
                turn: 1,
                date:''
            },
            selectedTurno: '',
            ultimaFechaSeleccionada: null,
            lastSelectedDay: null,
            hourbycita: '',
            ofCall: [],
            selectedConRoom: "",
            schedule: [],
        }
    },
    created() {
            this.events = [];
            this.mtdGetHour();
            this.mtdGetConRoom();
    },
    watch: {
        events: {
            handler(newEvents) {
                this.calendarOptions.events = newEvents;
            },
            deep: true
        }
    },
    computed: {
    },
    methods: {
        ...mapActions(['get', 'post']),

        mtdGetConRoom: function () {  
            this.get({
                url: this.$store.getters.get__url + "/Venta/consultorio/" + this.$store.getters.get__campus,
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.conRoom = response.data;
            })    
        },

        mtdSelectTab: function (id) {
            let doctor_id = this.elementProcess.doctor ? this.elementProcess.doctor.id : null;
            this.post({
                url: this.$store.getters.get__url + "/Admision/consul/filter",
                token: this.$store.getters.get__token,
                params: {
                    subsub: this.elementProcess.id,
                    room: id,
                    doctor_id: doctor_id ,
                    date: this.quote.date
                },
            })
            .then((response) => {
                this.schedule = response.data;
            })
            .catch((errors) => { });
        },

        mtdGetHour: function () {
            this.post({
                url: this.$store.getters.get__url + "/Admision/bringDate",
                token: this.$store.getters.get__token,
                params: {
                    Campus: this.$store.getters.get__campus,
                    doctor: this.elementProcess.doctor.id,
                },
            })
            .then((response) => {
                this.ofCall = response.data;
                this.bringDate();
            })
            .catch(error => {
                console.log(error);
            })
        },

        bringDate: function () {
            this.events = [];
            const eventCount = {};
            if (this.ofCall.CONSULTAS && Array.isArray(this.ofCall.CONSULTAS)) {
                this.ofCall.CONSULTAS.forEach(date => {
                    const day = date.split('T')[0];
                    const eventType = "CONSULTAS";
                    if (!eventCount[day]) {
                        eventCount[day] = {};
                    }
                    if (!eventCount[day][eventType]) {
                        eventCount[day][eventType] = 0;
                    }
                    eventCount[day][eventType]++;
                    eventCount[day][eventType + '_event'] = {
                        title: `${eventType}-${eventCount[day][eventType]}`,
                        start: date,
                        backgroundColor: "blue",
                        borderColor: "blue",
                        textColor: "white"
                    };
                });
            }

            if (this.ofCall.CIRUJIAS && Array.isArray(this.ofCall.CIRUJIAS)) {
                this.ofCall.CIRUJIAS.forEach(date => {
                    const day = date.split('T')[0];
                    const eventType = "CIRUGIAS";
                    if (!eventCount[day]) {
                        eventCount[day] = {};
                    }
                    if (!eventCount[day][eventType]) {
                        eventCount[day][eventType] = 0;
                    }
                    eventCount[day][eventType]++;
                    eventCount[day][eventType + '_event'] = {
                        title: `${eventType}-${eventCount[day][eventType]}`,
                        start: date,
                        backgroundColor: "green",
                        borderColor: "green",
                        textColor: "white"
                    };
                });
            }
            Object.values(eventCount).forEach(dayEvents => {
                Object.values(dayEvents).forEach(event => {
                    if (typeof event === 'object') {
                        this.events.push(event);
                    }
                });
            });
        },

        dateClick: function (info) {
            const date2 = new Date(info.date);
            const date = info.dateStr
            const olddate = new Date();
            var ano = olddate.getFullYear();
            var mes = ('0' + (olddate.getMonth() + 1)).slice(-2);
            var dia = ('0' + olddate.getDate()).slice(-2);
            var fechaFormateada = ano + '-' + mes + '-' + dia;
            if (date < fechaFormateada) {
                this.$refs.SweetAlert.showWarning("Elija una Fecha Válida");
            } else {
                const auxiliar = this.fixDate(date2, "date-en");
                this.quote.date = moment(auxiliar, 'YYYY-MM-DD').format('DD/MM/YYYY');
                this.quote.dateStr=moment(auxiliar, 'YYYY-MM-DD').format('YYYY-MM-DD');
                this.ultimaFechaSeleccionada = date;  
                this.updateDate();
            }
        },

        updateDate: function() {
            this.selectedConRoom = "";
            this.schedule = [];
            this.selectedHour = ''
        },

        fixDate(date, type) {
            let dateFixed = "";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hours = "";
            switch (type) {
                case "date-es":
                    if (date.getDate() < 10) day = "0" + day;
                    dateFixed = `${day}/${month}/${year}`;
                    break;
                case "date-en":
                    if (date.getDate() < 10) day = "0" + day;
                    dateFixed = `${year}-${month}-${day}`;
                    break;
                case "time":
                    date.getHours() < 10 ?
                        (hours += "0" + date.getHours()) :
                        (hours = date.getHours());
                    dateFixed = `${hours}:${date
                        .getMinutes()
                        .toString()
                        .padStart(2, "0")}`;
                    break;

                default:
                    break;
            }
            return dateFixed;
        },

        clearData: function () {
            this.quote = {
                dateStr: '',
                campu_id: null,
                turn: 1,
                date:''
            };
            this.selectedHour = '';
            this.selectedConRoom = "";

            this.conRoom = [];
            this.schedule = [];
            this.ofCall = [];
            this.events = [];
            this.ultimaFechaSeleccionada = null
        },

        mtdNextStep: function () {
       
            if (
                this.quote.dateStr!=''&&
                this.selectedHour!=''&&
                this.selectedConRoom!=''
            ) {
                this.elementProcess.data = {
                    date: moment(this.quote.dateStr, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    hour:this.selectedHour,
                    room: this.selectedConRoom,
                    doctor: this.elementProcess.doctor ? this.elementProcess.doctor.id : null
                };
                this.elementProcess.programado = true;

                //console.log(this.elementProcess);
                this.$emit("mtdNextProcess", this.elementProcess);
                this.clearData();

            } else {
                this.$refs.SweetAlert.showWarning("Seleccione Fecha, Consultorio y Hora");
            }
            
        },

        mtdBehindStep: function () {
            this.$emit("mtdBehindProcess", this.elementProcess);
        },

        selectHour(hour) {
            this.selectedHour = hour;
        },
    }
}
</script>

<style scoped>
.cursor {
    cursor: pointer;
}

.align {
    display: block;
    text-align: left;
}

/*leyenda*/
.legend-item {
    display: flex;
    align-items: center;
    margin-right: 15px;
}

.circle {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    border-radius: 50%;
}
.btn-blue {
    background-color: #4bbedd !important; /* Color amarillo */
    border-color: #4bbedd !important;
}
.btn-warning {
    background-color: #ffc107 !important; /* Color amarillo */
    border-color: #ffc107 !important;
}

.text-white {
    color: #ffffff !important; /* Texto blanco */
}
.table-responsive {
    max-height: 300px; 
    overflow-y: auto;
    display: block;
}

.font-hour-state {
    font-size: 13px
}
</style>